export default {
  interviewMethod: '面接方法',
  duration: '面接所要時間',
  interviewTime: '面接時間',
  meetingLink: '面接リンク',
  interviewLocation: '面接場所',
  note: 'メモ欄',
  availableTimeSlots: '候補の時間帯',
  mins: '分',
  interviewCancel: '面接日程はキャンセルされました',
  rejectButton: '再調整依頼',
  rejectDialogButton: '提出',
  acceptButton: '面接招待承諾',
  acceptDialogButton: '提出',
  rejectMessage: '提出完了',
  selectTimeWarning: '時間帯を選択してください',
  acceptMessage: '面接の招待を承諾しました。選択した時間：{time}',
  fetchError: '面接情報の取得に失敗しました',
  candidate: '候補者',
  to: 'から',
  accepted: '面接招待承諾',
  rejected: '面接時間の再調整',
  expired: '面接招待失効',
  rejectionReason: 'メモ欄：',
  online: 'Web',
  offline: '対面',
  interviewInvitation: '面接招待',
  rejectSuccess: '提出完了',
  rejectError: '提出に失敗しました',
  acceptSuccess: '提出完了',
  acceptError: '提出に失敗しました',
  invalidTimeSlot: '無効な時間帯',
  rejectDialogTitle: '面接時間の再調整依頼',
  rejectDialogLabel: 'メモ欄',
  rejectReasonPlaceholder: '面接に都合の良い時間を提示してください',
  cancelButton: 'キャンセル',
  acceptDialogTitle: '面接招待承諾',
  defaultNote: '時間通りに参加できない場合は、事前にお知らせください',
  pleaseSelectInterviewer: '面接官を選択してください',
  pleaseSelectInterviewMethod: '面接方法を選択してください',
  pleaseEnterInterviewDuration: '面接時間を入力してください',
  pleaseEnterValidNumber: '有効な数字を入力してください',
  durationMustBeGreaterThanZero: '面接時間は0より大きい必要があります',
  pleaseEnterInterviewAddress: '面接場所を入力してください',
  pleaseAddAtLeastOneTimeSlot: '面接可能な時間帯を設定してください',
  pleaseCompleteAllTimeSlotInfo: '面接可能な時間帯に空欄があります',
  timeSlotMustNotBeLessThanDuration: '面接可能な時間帯は、面接の所要時間以上で設定してください',
  pleaseEnterInterviewLink: '面接リンクを入力してください',
  timeSlotExpired: '選択された面接時間は有効期限が過ぎています。再度選択してください。',
  noPermission: '閲覧権限がありません',
  needAgentConfirm: 'エージェント確認待ち',
};
